/* Text and GIF to explain how the calendar works */
const CalendarGuide = () => {
  return (
    <div className="calendar_guide-wrapper">
      <img src="./assets/swipe2.gif" alt="wisch-geste" />
      <p style={{ color: "#fff" }}>
        Nicht alle Türchen sind im Sichtbereich! Um das aktuelle zu finden,
        verschiebe mit der gedrückten Maustaste oder per Touchscreen den
        Ausschnitt – dann wirst du fündig!
      </p>
    </div>
  );
};

export default CalendarGuide;
